import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Alert
} from '@mui/material';
import './SearchCard.scss';

const SearchCard = ({
  searchBy,
  searchInput,
  errorMessage,
  isSearchEnabled,
  onSearchByChange,
  onSearchInputChange,
  onSearch,
  getPlaceholder
}) => {
  return (
    <Card className="search-card" data-testid="search-card">
      <CardContent>
        <Box className="search-form">
          <Typography variant="body1" className="search-label">
            Search by:
          </Typography>
          
          <FormControl className="search-select">
            <InputLabel className="search-select-label">Select an option</InputLabel>
            <Select
              value={searchBy}
              onChange={onSearchByChange}
              label="Select an option"
              className="search-select-input"
              data-testid="select-container"
            >
              <MenuItem value="phone">
                Phone Number
              </MenuItem>
              <MenuItem value="sapid">
                SAP ID
              </MenuItem>
            </Select>
          </FormControl>

          <TextField
            value={searchInput}
            onChange={onSearchInputChange}
            placeholder={getPlaceholder()}
            className="search-input"
          />

          <Button
            variant="contained"
            onClick={onSearch}
            disabled={!isSearchEnabled}
            className="search-button"
          >
            SEARCH
          </Button>
        </Box>

        {errorMessage && (
          <Alert 
            severity="error" 
            className="error-message"
          >
            {errorMessage}
          </Alert>
        )}
      </CardContent>
    </Card>
  );
};

export default SearchCard;
